/**
 * Modal View
 * Used as the default base modal view in modal.js
 *
 * @author dkvistgaard <dkvistgaard@vertic.com>
 */

import Handlebars from 'handlebars';

// Framework
import BackboneView from '../../framework/view';

const View = BackboneView.extend({
	className() {
		return this.options && this.options.type ? `modal__body is-modal--${this.options.type}` : 'modal__body';
	},

	events: {
		'click .products__card__details button': 'onViewDetailsClick',
		'change .hs-marketing_material_consent input': 'onCheckboxValueChange',
	},

	onCheckboxValueChange(e) {
		window.gtmDataMarketingCheckboxChecked = e.delegateTarget.checked;
	},

	getTemplate() {
		let templateElement;
		let template = '';

		switch (this.options.type) {
			case 'generic-signup-modal':
				templateElement = 'modal-signup';
				break;
			case 'generic-signup-complete':
				templateElement = 'modal-signup-complete';
				break;
			case 'generic-productdetails-modal':
				templateElement = 'modal-productdetails';
				this.el.classList.add('overlay');
				break;
			default:
				templateElement = '';
				break;
		}

		if (templateElement) {
			const element = document.getElementById(templateElement);
			template = element.innerText;
		}

		return Handlebars.compile(template);
	},

	render() {
		this.el.innerHTML = this.getTemplate()(this.model.toJSON());

		setTimeout(() => {
			this.el.classList.add('modal--show');
		}, 0);

		return this;
	},

	onViewDetailsClick(e) {
		const productId = {
			id: e.delegateTarget.dataset.productId,
		};
		this.api.get('/api/products', productId, this.openDetailsModal.bind(this), false);
	},

	openDetailsModal(productData) {
		const productDetails = JSON.parse(productData.response);

		App.modal.create({
			type: 'generic-productdetails-modal',
			model: {
				productDetails,
			},
		});
	},

	api: {
		get(baseUrl, params, callback, emptyContainer) {
			const queryString = Object.keys(params).map((key) => {
				return `${key}=${params[key]}`;
			}).join('&');

			const url = encodeURI(`${baseUrl}?${queryString}`);

			const xhttp = new XMLHttpRequest();
			xhttp.onreadystatechange = function onreadystatechange() {
				if (this.readyState === 4 && this.status === 200) {
					callback(this, emptyContainer);
				}
			};

			xhttp.open('GET', url, true);
			xhttp.send();
		},
	},
});

export default View;
